import React, { useEffect, useState } from 'react';
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import { TStore, useAppDispatch } from '../../store';
import { useSelector } from 'react-redux';
import { userLogin } from '../../actions/userActions';
import c4clogo from '../../images/c4c_logo.png'

// Redirect to HTTPS in production so credentials are never sent over plain HTTP.
if (process.env.NODE_ENV === 'production' && window.location.protocol !== 'https:') {
  window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`);
}

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [api, contextHolder] = notification.useNotification();
    const { loading, error, userToken } = useSelector((state: TStore) => state.user);

    // Controlled inputs — avoids fragile event.target[0]/[1] index access.
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    useEffect(() => {
        if (userToken?.length != 0) navigate('/');
        if (error) {
            api.error({
                message: error,
                description: "Unable to connect to server",
                placement: 'bottomRight',
                duration: 5
            });
        }
    }, [userToken, error]);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        dispatch(userLogin({ email, password }));
    }

    return (
        <div className="login">
            {contextHolder}
            <div className="login__form">
                <picture>
                    <img className="login__logo" src={c4clogo} alt="C4C logo" />
                </picture>
                <form className="form" onSubmit={handleSubmit}>
                    <div className="mb-md">
                        <h2 className="login__heading">
                            Sign in
                        </h2>
                        <p>Please enter your credentials below to continue</p>
                    </div>

                    <div className="form__group">
                        {/* type="email" triggers the correct mobile keyboard and native validation */}
                        <input
                            type="email"
                            className="form__input"
                            placeholder="Email"
                            id="usernameOrEmail"
                            autoComplete="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <label htmlFor="usernameOrEmail" className="form__label">Email</label>
                    </div>

                    <div className="form__group">
                        <input
                            type="password"
                            className="form__input"
                            placeholder="Password"
                            id="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <label htmlFor="password" className="form__label">Password</label>
                    </div>

                    <div className="form__group">
                        <button className="btn" type="submit" disabled={loading}>
                            {loading ? 'Signing in…' : 'Log In →'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Login;
